import { createSlice } from "infrastructure/store/lib";
import { sliceMixin } from "infrastructure/store/reducers";
import { ApiState } from "infrastructure/api";
import {
    transactionRequestFulfilled,
    transactionsRequestFulfilled,
    transactionsRequestLoading,
    transactionsRequestRejected
} from "./reducers";
import initialState, { sliceToken } from "./state";
import {
    getTransactionDetailsThunk,
    getTransactionsThunk
} from "./thunks";
import type { TransactionsState } from "./types";

const slice = createSlice({
    name: sliceToken,
    initialState,
    reducers: sliceMixin<TransactionsState>(initialState),
    extraReducers: builder =>
        builder
            // Transactions
            .addCase(getTransactionsThunk.pending, transactionsRequestLoading)
            .addCase(getTransactionsThunk.fulfilled, transactionsRequestFulfilled)
            .addCase(getTransactionsThunk.rejected, transactionsRequestRejected)
            // Transaction details
            .addCase(getTransactionDetailsThunk.pending, state => {
                state.transactionDetailsLoadingState = ApiState.Pending;
            })
            .addCase(getTransactionDetailsThunk.fulfilled, transactionRequestFulfilled)
            .addCase(getTransactionDetailsThunk.rejected, state => {
                state.transactionDetailsLoadingState = ApiState.Failed;
            })
});

export const {
    name,
    actions: {
        changeExportLoading,
        resetState
    }
} = slice;

export default slice.reducer;
